export default __webpack_public_path__ + "images/15ab0468fd5c347634f850906b590274-spa_small.webp";